module.exports = __webpack_public_path__ + "img/andre-dufet.102e1fc5.jpg";